import React, { FC } from "react";
import { StyledAlert, AlertContainer } from "./elements";

type AlertProps = {
  type: "success" | "error";
  message: string;
  showIcon?: boolean;
  width?: number;
  bottom?: number;
};

const Alert: FC<AlertProps> = props => {
  const { type, message, showIcon, width, bottom } = props;

  return (
    <AlertContainer>
      <StyledAlert width={width} bottom={bottom} type={type} message={message} showIcon={showIcon} />
    </AlertContainer>
  );
};

export default Alert;
